/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { CountryRegionCtsm } from '../models/CountryRegionCtsm';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class OtherClinTrakDataService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @returns CountryRegionCtsm
     * @throws ApiError
     */
    public otherClinTrakDataGetAllCountries(): Observable<Array<CountryRegionCtsm>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/clintrak/other/countries',
        });
    }
}
